import React, { Fragment } from 'react';
import { Col, Button } from "reactstrap";
import { SelectForm } from "../../Basicos/index";

// Filtro genérico por Período Letivo / Semestre — filtra client-side sobre os `dados` já
// carregados, batendo direto nas colunas periodo_letivo_id/semestre_id de cada registro. Os
// dois são independentes entre si (sem encadeamento). Irmão de FiltrosPeriodoSemestreTurma,
// pra telas que não têm o conceito de turma (ex.: Período de Seleção de Grupo).
const FiltrosPeriodoSemestre = ({ novoOnClick, filtros, dados, setDadosFiltrados, valoresFiltro, setValoresFiltro }) => {
    const { periodos_letivos, semestres } = filtros || {};

    const periodosOptions = periodos_letivos && periodos_letivos.map(p => ({ value: p.id, label: p.descricao }));
    const semestresOptions = semestres && semestres.map(s => ({ value: s.id, label: s.descricao }));

    const style = {
        col: { xs: 12, md: 3, sm: 3, lg: 3, xl: 3 }
    }

    const onChangeSelect = (nome, valor) => {
        const novosValores = { ...valoresFiltro, [nome]: valor };
        setValoresFiltro(novosValores);

        let dadosFiltrados = dados || [];

        if (novosValores.periodo_letivo_id) {
            dadosFiltrados = dadosFiltrados.filter(d => d.periodo_letivo_id == novosValores.periodo_letivo_id);
        }
        if (novosValores.semestre_id) {
            dadosFiltrados = dadosFiltrados.filter(d => d.semestre_id == novosValores.semestre_id);
        }

        setDadosFiltrados(dadosFiltrados);
    }

    return (
        <Fragment>
            <SelectForm
                label="Período Letivo"
                name="periodo_letivo_id"
                placeholder="Período"
                options={periodosOptions}
                onChange={onChangeSelect}
                value={periodosOptions && periodosOptions.find(option => (option.value === valoresFiltro.periodo_letivo_id)) || ''}
                style={{ col: style.col }}
                menuPortalTarget={document.body}
            />
            <SelectForm
                label="Semestre"
                name="semestre_id"
                placeholder="Semestre"
                options={semestresOptions}
                onChange={onChangeSelect}
                value={semestresOptions && semestresOptions.find(option => (option.value === valoresFiltro.semestre_id)) || ''}
                style={{ col: style.col }}
                menuPortalTarget={document.body}
            />

            <Col className="d-flex align-items-end mb-3" md={3} sm={12}>
                <Button className="mr-3 py-2 btn-secondary"
                    onClick={() => {
                        setValoresFiltro({
                            periodo_letivo_id: undefined,
                            semestre_id: undefined
                        });
                        setDadosFiltrados(dados);
                    }}>Limpar</Button>
                <Button className="py-2 btn-primary" onClick={novoOnClick}>Novo</Button>
            </Col>
        </Fragment>
    )
}

export default FiltrosPeriodoSemestre;
